import {createSlice, PayloadAction} from "@reduxjs/toolkit";

interface LocaleState {
    locale: string;
}

// Загружаем сохраненный язык из localStorage
const savedLocale = typeof window !== 'undefined' ? localStorage.getItem('admin_dashboard_locale') : '';

const initialState: LocaleState = {
    locale: savedLocale || '',
};

const localeSlice = createSlice({
    name: "locale",
    initialState,
    reducers: {
        setLocale: (state, action: PayloadAction<string>) => {
            state.locale = action.payload;
            // Сохраняем выбранный язык в localStorage
            if (typeof window !== 'undefined') {
                localStorage.setItem('admin_dashboard_locale', action.payload);
            }
        },
    },
});

export const {setLocale} = localeSlice.actions;

export default localeSlice.reducer;

